import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { VehicleStatusChecklistDto } from 'dtos/vehicles/statusChecklist'

const baseUrl = (vehicleGuid: string): string => `/api/vehicles/${encodeURIComponent(vehicleGuid)}/status-checklist`

export const getStatusChecklsit = (vehicleGuid: string) => apiClient.get<ApiResponse<VehicleStatusChecklistDto>>(baseUrl(vehicleGuid)).then(res => res.data)
